export default __webpack_public_path__ + "static/media/ruleStatus.65ebcb7b.svg";